// Normalizzazione province italiane: unifica sigla / nome / varianti di maiuscole/accenti
// in un'unica chiave canonica (la sigla a 2 lettere), con etichetta "SIGLA — Nome".

export const SIGLA_TO_NAME = {
  AG: "Agrigento", AL: "Alessandria", AN: "Ancona", AO: "Aosta", AP: "Ascoli Piceno",
  AQ: "L'Aquila", AR: "Arezzo", AT: "Asti", AV: "Avellino", BA: "Bari", BG: "Bergamo",
  BI: "Biella", BL: "Belluno", BN: "Benevento", BO: "Bologna", BR: "Brindisi", BS: "Brescia",
  BT: "Barletta-Andria-Trani", BZ: "Bolzano", CA: "Cagliari", CB: "Campobasso", CE: "Caserta",
  CH: "Chieti", CL: "Caltanissetta", CN: "Cuneo", CO: "Como", CR: "Cremona", CS: "Cosenza",
  CT: "Catania", CZ: "Catanzaro", EN: "Enna", FC: "Forlì-Cesena", FE: "Ferrara", FG: "Foggia",
  FI: "Firenze", FM: "Fermo", FR: "Frosinone", GE: "Genova", GO: "Gorizia", GR: "Grosseto",
  IM: "Imperia", IS: "Isernia", KR: "Crotone", LC: "Lecco", LE: "Lecce", LI: "Livorno",
  LO: "Lodi", LT: "Latina", LU: "Lucca", MB: "Monza e della Brianza", MC: "Macerata",
  ME: "Messina", MI: "Milano", MN: "Mantova", MO: "Modena", MS: "Massa-Carrara", MT: "Matera",
  NA: "Napoli", NO: "Novara", NU: "Nuoro", OR: "Oristano", PA: "Palermo", PC: "Piacenza",
  PD: "Padova", PE: "Pescara", PG: "Perugia", PI: "Pisa", PN: "Pordenone", PO: "Prato",
  PR: "Parma", PT: "Pistoia", PU: "Pesaro e Urbino", PV: "Pavia", PZ: "Potenza", RA: "Ravenna",
  RC: "Reggio Calabria", RE: "Reggio Emilia", RG: "Ragusa", RI: "Rieti", RM: "Roma", RN: "Rimini",
  RO: "Rovigo", SA: "Salerno", SI: "Siena", SO: "Sondrio", SP: "La Spezia", SR: "Siracusa",
  SS: "Sassari", SU: "Sud Sardegna", SV: "Savona", TA: "Taranto", TE: "Teramo", TN: "Trento",
  TO: "Torino", TP: "Trapani", TR: "Terni", TS: "Trieste", TV: "Treviso", UD: "Udine",
  VA: "Varese", VB: "Verbano-Cusio-Ossola", VC: "Vercelli", VE: "Venezia", VI: "Vicenza",
  VR: "Verona", VT: "Viterbo", VV: "Vibo Valentia",
};

const stripAccents = (s) => s.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
// "chiave compatta": maiuscolo, senza accenti, senza spazi/apostrofi/trattini/punteggiatura
const squash = (s) => stripAccents(String(s).toUpperCase()).replace(/[^A-Z0-9]/g, "");

// nome compatto -> sigla, generato dalla mappa + alias comuni / province storiche abolite
const NAME_TO_SIGLA = {};
for (const [sigla, name] of Object.entries(SIGLA_TO_NAME)) {
  NAME_TO_SIGLA[squash(name)] = sigla;
}
Object.assign(NAME_TO_SIGLA, {
  [squash("Reggio nell'Emilia")]: "RE", [squash("Reggio di Calabria")]: "RC",
  [squash("Monza")]: "MB", [squash("Monza e Brianza")]: "MB",
  [squash("Pesaro")]: "PU", [squash("Valle d'Aosta")]: "AO", [squash("Bozen")]: "BZ",
  [squash("Massa e Carrara")]: "MS", [squash("Massa Carrara")]: "MS",
  // province storiche abolite -> province attuali
  [squash("Medio Campidano")]: "SU", [squash("Carbonia-Iglesias")]: "SU",
  [squash("Olbia-Tempio")]: "SS", [squash("Ogliastra")]: "NU",
});

// Ritorna la chiave canonica (sigla) per un valore provincia qualsiasi.
export function normalizeProvince(raw) {
  if (!raw) return null;
  const t = String(raw).trim();
  if (!t) return null;
  const up = stripAccents(t.toUpperCase());
  if (up.length === 2 && SIGLA_TO_NAME[up]) return up;
  const sq = squash(up);
  if (NAME_TO_SIGLA[sq]) return NAME_TO_SIGLA[sq];
  return up; // fallback: mantiene visibili valori sconosciuti, unificando comunque le varianti di maiuscole/accenti
}

// Etichetta leggibile "SIGLA — Nome" (o il valore grezzo se sigla non nota).
export function provinceLabel(key) {
  if (!key) return "";
  const name = SIGLA_TO_NAME[key];
  return name ? `${key} — ${name}` : key;
}
